let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eDj38")).then(() => parcelRequire('GD4O9'));